import { motion } from "framer-motion";

export default function Hero() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="text-center pt-16 pb-10 px-4"
    >

      {/* Top badge */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="inline-block border border-blue-500 text-blue-400 px-4 py-1 rounded-full text-sm mb-6"
      >
        AVAILABLE TO BUILD, SHIP, AND COLLABORATE
      </motion.div>

      {/* Name */}
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="text-4xl md:text-7xl font-bold tracking-wide"
      >
        SAURABH
      </motion.h1>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="text-4xl md:text-7xl font-bold text-gray-700 mt-2"
      >
        GUPTA
      </motion.h2>

      {/* Description */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="mt-4 text-gray-400 max-w-2xl mx-auto"
      >
        Innovative Mobile Architect & Senior <span className="font-bold text-white">iOS & Flutter Engineer</span> with expertise in scalable architectures, 
        SDK development, and performance optimization—delivering secure, 
        high-impact applications with exceptional user experience.
        {/* Senior <span className="font-bold text-white">iOS & Flutter</span> Engineer with deep expertise in mobile architecture, 
        SDK design, performance optimization, 
        and fintech security, delivering real-world applications that balance clean UX with robust engineering. */}
      </motion.p>

      {/* Buttons */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="mt-6 flex justify-center gap-4"
      >
        <a
          href="#projects"
          className="bg-blue-600 px-6 py-3 rounded-lg 
          hover:bg-blue-700 hover:scale-105 active:scale-95 
          transition duration-300"
        >
          Explore Projects →
        </a>

        <a
          href="#contact"
          className="border border-gray-600 px-6 py-3 rounded-lg 
          hover:bg-gray-800 hover:scale-105 active:scale-95 
          transition duration-300"
        >
          Contact Me
        </a>
      </motion.div>

      {/* Line */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7 }}
        className="mt-6 max-w-4xl mx-auto"
      >
        <section className="pt-5 pb-5 px-4"></section>
        <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-blue-400 to-transparent opacity-80"></div>
      </motion.div>

      {/* Stats */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="mt-6 md:mt-8 grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 text-center max-w-4xl mx-auto"
      >
        <div className="space-y-1">
          <h3 className="text-xl md:text-2xl font-bold">10+</h3>
          <p className="text-gray-400 text-xs md:text-sm">Years Experience</p>
        </div>

        <div className="space-y-1">
          <h3 className="text-xl md:text-2xl font-bold">50+</h3>
          <p className="text-gray-400 text-xs md:text-sm">Apps Delivered</p>
        </div>

        <div className="space-y-1">
          <h3 className="text-xl md:text-2xl font-bold">100K+</h3>
          <p className="text-gray-400 text-xs md:text-sm">Installs</p>
        </div>

        <div className="space-y-1">
          <h3 className="text-xl md:text-2xl font-bold">100%</h3>
          <p className="text-gray-400 text-xs md:text-sm">Clean Architecture</p>
        </div>
      </motion.div>

    </motion.section>
  );
}